import { lazy, Suspense } from 'react';
import { GuestApp } from './guest/GuestApp';
import { Join } from './guest/Join';
import { usePath } from './lib/router';
import { Floor } from './staff/Floor';
import { FloorEdit } from './staff/FloorEdit';
import { Kitchen } from './staff/Kitchen';
import { MenuEditor } from './staff/MenuEditor';
import { OrderPad } from './staff/OrderPad';
import { Settings } from './staff/Settings';
import { Storefront } from './staff/Storefront';
import { TakeoutStart } from './guest/TakeoutStart';
import { Tables } from './staff/Tables';
import { Callback, Owner } from './staff/Owner';
import { Mango } from './ui/icons';

const TownPreview = lazy(() => import('./town/TownPreview'));
/** FirstMango Town is a dev-only preview until shops can opt in (docs/PLAN.md, Town T1/T2). */
const TOWN_PREVIEW = /^(dev\.|localhost$|127\.)/.test(location.hostname);

export function App() {
  const path = usePath();
  if (path.startsWith('/j/')) return <Join code={decodeURIComponent(path.slice(3))} />;
  if (path.startsWith('/k/')) return <TakeoutStart code={decodeURIComponent(path.slice(3))} />;
  if (path.startsWith('/order/')) return <OrderPad path={path} sessionId={path.slice(7)} />;
  if (path === '/settings') return <Settings path={path} />;
  if (path === '/storefront') return <Storefront path={path} />;
  if (path === '/t' || path.startsWith('/t/')) return <GuestApp path={path} />;
  if (path === '/auth/callback') return <Callback />;
  if (path === '/owner') return <Owner />;
  if (path === '/kitchen') return <Kitchen path={path} />;
  if (path === '/floor') return <Floor path={path} />;
  if (path === '/floor/edit') return <FloorEdit path={path} />;
  if (path === '/menu') return <MenuEditor path={path} />;
  if (path === '/tables') return <Tables path={path} />;
  if (path === '/town' && TOWN_PREVIEW) return <Suspense fallback={<main className="screen center"><p className="muted">กำลังโหลดเมือง · Loading the town…</p></main>}><TownPreview /></Suspense>;
  return (
    <main className="screen center">
      <div className="logo" style={{ width: 64, height: 64 }}><Mango /></div>
      <h1 className="display" style={{ margin: 0, fontSize: 32 }}>FirstMango</h1>
      <p className="muted" style={{ margin: 0 }}>สแกน QR ที่โต๊ะเพื่อสั่งอาหาร · Scan the QR code on your table to order</p>
      <a href="/owner" style={{ fontWeight: 700 }}>สำหรับเจ้าของร้าน · For restaurant owners</a>
    </main>
  );
}
